import { useParams, Navigate } from "react-router-dom";
import { ISSUES, UI } from "../data/content";
import { Reveal, HeroBand, SectionHead, RelatedLinks, ContactModule, usePageMeta } from "../components/kit";

export default function IssuePage() {
  const { slug } = useParams();
  const u = ISSUES.find((x) => x.slug === slug);
  usePageMeta(u ? `${u.name} | KairosHK` : "KairosHK", u?.card);
  if (!u) return <Navigate to="/issues" replace />;

  return (
    <div data-testid={`issue-page-${u.slug}`}>
      <HeroBand image={u.image} eyebrow={UI.nav.issues} title={u.name} standfirst={u.card} compact />

      <section className="k-section !pb-10">
        <div className="k-container max-w-4xl !mx-0">
          <Reveal>
            {u.preamble.map((p, i) => (
              <p key={i} className={`text-lg leading-relaxed mb-5 ${i > 0 ? "text-ink-muted" : ""}`}>{p}</p>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="k-section !py-14 bg-paper-alt">
        <div className="k-container">
          <SectionHead eyebrow={u.name} title={UI.common.howWeAdvise.replace(":", "")} />
          <ul className="list-none p-0 m-0 space-y-3 max-w-3xl" data-testid="issue-points">
            {u.points.map((p, i) => (
              <Reveal key={i} delay={i * 0.04}>
                <li className="flex gap-4 leading-relaxed text-[0.95rem]">
                  <span className="text-brand font-semibold shrink-0">—</span>{p}
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <section className="k-section !py-14">
        <div className="k-container">
          <Reveal><RelatedLinks items={u.related} /></Reveal>
        </div>
      </section>

      <section className="k-container pb-20">
        <ContactModule />
      </section>
    </div>
  );
}
